import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { modal } from 'react-redux-modal';
import Scroll from 'react-scroll';

import {
  SignUpModalView,
  LoginModalView,
  ComingSoonModal,
  FeedbackModal,
} from '../../components';
import { isSubdomain } from '../../utils';

import { authLogout } from '../../actions/auth';

import './style.scss';
import { NeverStopView } from '../Modals';

const defaultProps = {
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
  sectionName: 'Livecams',
};

const contextTypes = {
  router: PropTypes.object.isRequired,
};

class SideNav extends React.Component {

  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.logIn = this.logIn.bind(this);
    this.signUp = this.signUp.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
    this.onNeverStop = this.onNeverStop.bind(this);
  }

  closeMenu (e) {
    if(e) {
      e.preventDefault();
    }
    var sideNavWrapper = $('.side-nav-wrapper');
    sideNavWrapper.toggleClass('is-open');
    $('.site-wrapper').off('click');
  }

  onFeedback(e){
    if(e) {
      e.preventDefault();
    }
    this.closeMenu();
    modal.add(FeedbackModal, {size:'medium', hideTitleBar: true});
  }

  onNeverStop(e){
    if(e) {
      e.preventDefault();
    }
    this.closeMenu();
    modal.add(NeverStopView, {size:'medium', hideTitleBar: true});
  }

  logOut (e) {
    e.preventDefault();
    this.props.dispatch(authLogout());
  }

  signUp (e) {
    e.preventDefault();
    modal.add(SignUpModalView, {title:'', size:'medium', hideTitleBar: true})
    this.closeMenu();
  }

  logIn (e) {
    e.preventDefault();
    modal.add(LoginModalView, {title:'', size:'medium', hideTitleBar: true})
    this.closeMenu();
  }
  onMenuClick(e) {
    e.preventDefault();
    this.context.router.push(e.currentTarget.pathname)
    this.closeMenu();
  }

  onGuidelinesClick(e) {
    Scroll.animateScroll.scrollToTop();
    this.onMenuClick(e);
  }

  onComingSoon (e) {
    if (e) e.preventDefault();
    modal.add(ComingSoonModal, {title:'', size:'medium', hideTitleBar: true})
  }

  render(){
    const {isAuthenticated, userName, isStaff, isSuperuser, sectionName, logo} = this.props;
    const loggedInMenu = (isAuthenticated) ? (
      <ul className="side-nav-account-buttons">
        <li className="text-center"><Link to={`/about-us`} onClick={this.onMenuClick}>about us</Link></li>
        <li className="text-center"><Link to={`/members/${userName}`} onClick={this.onMenuClick}>profile page</Link></li>
        <li className="text-center"><Link to="/livecams" onClick={this.onMenuClick}>livecams</Link></li>
        <li className="text-center"><Link to="/films" onClick={this.onMenuClick}>films</Link></li>
        {isSubdomain && <li className="text-center"><Link to="/photos" onClick={this.onMenuClick}>photo galleries</Link></li>}
        <li className="text-center"><a href="/snapshots/favorites/">snapshots</a></li>
        <li className="text-center"><Link to="/event-calendar" onClick={this.onMenuClick}>event calendar</Link></li>
        <li className="text-center"><Link to={`/research`} onClick={this.onMenuClick}>research</Link></li>
        <li className="text-center"><Link to={`/fat-bear-week`} onClick={this.onMenuClick}>fat bear week</Link></li>
        <li className="text-center"><Link to={`/education`} onClick={this.onMenuClick}>education</Link></li>
        <li className="text-center"><Link to={`/offtopic`} onClick={this.onMenuClick}>off-topic chat</Link></li>
        <li className="text-center"><a href="#" onClick={this.onNeverStop}>never stop learning</a></li>
        <li className="text-center"><Link to={`/testimonials`} onClick={this.onMenuClick}>testimonials</Link></li>
        <li className="text-center"><Link to={`/press`} onClick={this.onMenuClick}>press</Link></li>
        <li className="text-center"><a href="https://blog.explore.org" target="_blank">blog</a></li>
        <li className="text-center"><Link to="/help" onClick={this.onMenuClick}>frequently asked questions</Link></li>
        <li className="text-center"><Link to="/community-guidelines" onClick={this.onGuidelinesClick}>community guidelines</Link></li>
        <li className="text-center"><Link to="/youtube-community-guidelines" onClick={this.onGuidelinesClick}>youtube community guidelines</Link></li>
        <li className="text-center"><a href="#" onClick={this.onFeedback}>feedback</a></li>
        <li className="text-center"><Link to={`/volunteer`} onClick={this.onMenuClick}>volunteer</Link></li>
        <li className="text-center"><Link to="/accounts/logout" onClick={(e)=>{this.logOut(e)}}>logout</Link></li>
        {/*
        <li className="text-center"><Link to="/members" onClick={this.onMenuClick}>members</Link></li>
        <li className="text-center"><Link to="/grants" onClick={this.onMenuClick}>grants</Link></li>
        <li className="logged-in text-center textColor-fff hidden-sm-up">{userName}</li>
        <li className="logged-in text-center"><a href={userSnapshots} >my snapshots</a></li>
        <li className="logged-in text-center"><a href={userFavoriteSnapshots} >favorite snapshots</a></li>
        <li className="logged-in text-center"><Link to={`/livecams/members/${userName}`} onClick={this.onMenuClick}>favorite livecams</Link></li>
        <li className="logged-in text-center"><Link to={`/members/${userName}`} onClick={this.onMenuClick}>profile page</Link></li>
        <li className="logged-in text-center"><Link to="/accounts/logout" onClick={(e)=>{this.logOut(e)}}>logout</Link></li>
        */}
        </ul>
    ) : (
      <ul className="side-nav-account-buttons">
        <li className="text-center"><Link to={`/about-us`} onClick={this.onMenuClick}>about us</Link></li>
        <li className="text-center"><Link to="/livecams" onClick={this.onMenuClick}>livecams</Link></li>
        <li className="text-center"><Link to="/films" onClick={this.onMenuClick}>films</Link></li>
        {isSubdomain && <li className="text-center"><Link to="/photos" onClick={this.onMenuClick}>photo galleries</Link></li> }
        <li className="text-center"><a href="/snapshots/favorites/">snapshots</a></li>
        <li className="text-center"><Link to="/event-calendar" onClick={this.onMenuClick}>event calendar</Link></li>
        <li className="text-center"><Link to={`/research`} onClick={this.onMenuClick}>research</Link></li>
        <li className="text-center"><Link to={`/fat-bear-week`} onClick={this.onMenuClick}>fat bear week</Link></li>
        <li className="text-center"><Link to={`/education`} onClick={this.onMenuClick}>education</Link></li>
        <li className="text-center"><Link to={`/offtopic`} onClick={this.onMenuClick}>off-topic chat</Link></li>
        <li className="text-center"><a href="#" onClick={this.onNeverStop}>never stop learning</a></li>
        <li className="text-center"><Link to={`/testimonials`} onClick={this.onMenuClick}>testimonials</Link></li>
        <li className="text-center"><Link to={`/press`} onClick={this.onMenuClick}>press</Link></li>
        <li className="text-center"><a href="https://blog.explore.org" target="_blank">blog</a></li>
        <li className="text-center"><Link to="/help" onClick={this.onMenuClick}>frequently asked questions</Link></li>
        <li className="text-center"><Link to="/community-guidelines" onClick={this.onMenuClick}>community guidelines</Link></li>
        <li className="text-center"><Link to="/youtube-community-guidelines" onClick={this.onMenuClick}>youtube community guidelines</Link></li>
        <li className="text-center"><a href="#" onClick={this.onFeedback}>feedback</a></li>
        <li className="text-center"><Link to={`/volunteer`} onClick={this.onMenuClick}>volunteer</Link></li>
        <li className="text-center"><Link to="#" onClick={(e)=>{this.logIn(e)}}>login</Link></li>
        <li className="text-center"><Link to="#" onClick={(e)=>{this.signUp(e)}}>join</Link></li>
        {/*
        <li className="text-center"><Link to="/members" onClick={this.onMenuClick}>members</Link></li>
        <li className="text-center"><Link to="/grants" onClick={this.onMenuClick}>grants</Link></li>
        <li className="logged-in text-center"><Link to="#" onClick={(e)=>{this.signUp(e)}}>join</Link></li>
        <li className="logged-in text-center"><Link to="#" onClick={(e)=>{this.logIn(e)}}>login</Link></li>
        */}
      </ul>
    );

    return (
      <div>
        <ul className="p-0 m-0 bg-000">
          <li className="textColor-fff d-flex pY-5 align-items-center justify-content-start">
            <a href="/" className="textColor-fff mL-65 side-nav-brand">
              <i className="icon-ExploreLogo textColor-fff d-none"></i>
              <img src={logo} className="explore-svg-logo" alt="Explore" />
            </a>
            <span className="search-label-nav text-uppercase u-font-foundation-light">Menu</span>
            <a href="#" className="u-textSize-20 textColor-fff side-nav-close" onClick={this.closeMenu}><i className="icon-X_Close_Square"/></a>
          </li>
        </ul>
        <div className="side-nav-list">
          {loggedInMenu}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userName: state.auth.userName,
    userId: state.auth.userId,
    statusText: state.auth.statusText,
    isAuthenticated: state.auth.isAuthenticated,
    isSuperuser: state.auth.isSuperuser,
    isStaff: state.auth.isStaff,
    sectionName: !_.isEmpty(ownProps.sectionName) ? ownProps.sectionName : state.globalConfig.currentSection,
    logo: state.globalConfig.logo,
  };
};

SideNav.defaultProps = defaultProps;
SideNav.contextTypes = contextTypes;

export default connect(mapStateToProps)(SideNav);
